// removed by extract-text-webpack-plugin
module.exports = {"actionPanel":"action-panel__actionPanel-2zTZd","actions":"action-panel__actions-9JNk7","backToOrderButton":"action-panel__backToOrderButton-1ndSv blocks__big-2DxLx blocks__white-2DChO blocks__button-1iODk","switchModeButton":"action-panel__switchModeButton-2QXdk blocks__big-2DxLx blocks__white-2DChO blocks__button-1iODk","downloadExcel":"action-panel__downloadExcel-hDYF2 blocks__big-2DxLx blocks__white-2DChO blocks__button-1iODk","redirect":"action-panel__redirect-13T0n","preloader":"action-panel__preloader-35mWp"};


//////////////////
// WEBPACK FOOTER
// ./components/account/statistic/action-panel/action-panel.css
// module id = 777
// module chunks = 0